import { apiClient } from "../api/client.js";

export async function trackPaymentEvent(
  sessionId: string,
  eventName: string,
  properties: Record<string, unknown> = {},
): Promise<void> {
  try {
    await apiClient["/api/v1/user/play-sessions/{id}/events"]["post"]({
      parameters: { id: sessionId },
      body: {
        events: [
          {
            client_id: crypto.randomUUID(),
            event_name: eventName,
            properties,
            client_timestamp: new Date().toISOString(),
          },
        ],
      },
    });
  } catch {
    // Analytics must never block payment UX.
  }
}
